<template>
    <div class="min_box">
      <keep-alive>
<!--        <div class="flex" >-->
<!--            <div><a-button class="top_btn" type="primary"   @click="exportList()"  >-->
<!--                批量导出-->
<!--            </a-button>-->
<!--                <span style="margin-left: 8px">-->
<!--        <template v-if="hasSelected">-->
<!--          {{ `选中 ${selectedRowKeys.length} 项` }}-->
<!--        </template></span></div>-->
<!--            <div class="search-group flex">-->
<!--                <a-input  v-model="search.name" placeholder="请输入行业名称搜索"  class="search-input" allowClear />-->
<!--                <a-button type="primary" class="top_btn" @click="getList()">搜索</a-button>-->
<!--                <a-button   class="top_btn" @click="empty">重置</a-button>-->
<!--            </div>-->
<!--        </div>-->
        <a-table  @expand="expand"  :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id" @change="handleChange"   >
            <span slot="customer_count" slot-scope="text, record">
                <a @click="gotoStatistics(record)">{{text}}</a>
<!--              <router-link :to="{path: '/DataStatistics/WebStatistics', query: {-->
<!--                  id: record.id ,-->
<!--                  name:record.name,-->
<!--                  type:'industry'-->
<!--                }}">{{text}}</router-link>-->
            </span>
        </a-table>
      </keep-alive>
    </div>

</template>

<script>
let tag = true;
let ArrList = JSON.parse(window.localStorage.getItem("industryArrparentidArr")) || [];;
    import API from "./api";
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [

      {
        title: "id",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "行业名称（中文）",
        dataIndex: "mname_ch",
        key: "mname_ch",
      },
      {
        title: "行业名称（英文）",
        dataIndex: "mname_en",
        key: "mname_en",
      },
      {
        title: "项目数量",
        dataIndex: "customer_count",
        key: "customer_count",
        scopedSlots: {customRender: "customer_count"}
      }
    ];
    export default {
        name: 'index',
        data() {
            return {
                loading: true,
                data: [],
                selectedRowKeys: [], // Check here to configure the default column
                columns,
                name:"",
                search: {
                    name: "",
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/Inquiry"; //设置左侧导航2-2 active
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {

     expand(e , rec) {
     console.log("expand",e)
       console.log("expandrec",rec)
       this.getList(rec.id,[...rec.arrparentid,rec.id])
    },
            empty(){
                this.search.name=""
                this.getList()
            },
            handleChange(pagination, filters, sorter) {
            },
            exportList(){
                API.service.EXPORT({name:this.name ,ids:this.selectedRowKeys }).then(res => {
                    window.open( `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`  )
                    // this.selectedRowKeys=[]
                })
            },

          async getList(parent_id,arrId) {
                let THAT=this
                let dataAll = JSON.parse(JSON.stringify(this.data))
                this.name=this.search.name
                API.service.GET_LIST({parent_id}).then(res => {
                  let listData=res
                  if(parent_id){
                    let copyArr=[]
                    const arrIdArr=(arrId, lastArr)=>{
                      if(copyArr.children){
                        copyArr.children.map((items, indexs) => {
                          if(items.id==arrId){
                            if(lastArr){
                              items.children=listData.data.data
                             THAT.data =dataAll
                            }
                            copyArr=items
                          }
                        })
                      }else{
                        dataAll.map((items, indexs) => {
                          if(items.id==arrId){
                            if(lastArr){
                              items.children=listData.data.data
                              THAT.data =dataAll
                            }
                            copyArr=items
                          }
                        })
                      }

                    }

                    arrId.map((items, indexs) => {
                      if(indexs==arrId.length-1){
                        arrIdArr(items ,true)
                      }else{
                        arrIdArr(items ,false)
                      }

                    })

                  }else{
                    this.data = res.data.data
                  }
                    this.loading = false
                })
            },

            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            gotoStatistics(row){
              // this.data=[]
              let id=[...row.arrparentid,row.id]
                 this.$router.push(`/DataStatistics/WebStatistics?id=${id}&name=${row.name}&type=industry`)
              // this.$router.push({
              //   name:'DataStatisticsList',
              //   params: {
              //     id: row.id ,
              //     name:row.name,
              //     type:"industry"
              //   }
              // })
            }
        },
        mounted() {
            this.getList()
        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    .search-group {
        float: right;
    }
    .search-group .search-input {
        width: 200px;height: 32px;
        margin: 0 8px 0 0 ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }
    .top .flex{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box;width: 60%;margin-bottom: 20px}
    /*.min_box{width: 60%}*/
</style>
